import classNames from "classnames";
import React, { useState } from "react";

import { useTranslation } from "react-i18next";
import "./styles.less";

export const SceneItem = ({
  title,
  lists,
  index,
  setCurrentIndex,
  currentIndex,
}) => {
  const className = classNames({
    "scene-item": true,
    actived: index === currentIndex,
  });
  return (
    <div
      className={className}
      onClick={() => {
        setCurrentIndex(index);
      }}
    >
      <div className="scene-item-title">{title}</div>
      {index === currentIndex && (
        <div className="scene-item-content">
          {lists.map((list) => (
            <div className="item-li">{list}</div>
          ))}
        </div>
      )}
    </div>
  );
};

export const TenantScene = (props) => {
  const { t } = useTranslation();
  const [currentIndex, setCurrentIndex] = useState(0);
  const SceneItemData = [
    {
      title: t("tenant.scene.item1.title"),
      lists: [t("tenant.scene.item1.list1"), t("tenant.scene.item1.list2")],
      img: t("tenant.scene.item1.img"),
    },
    {
      title: t("tenant.scene.item2.title"),
      lists: [t("tenant.scene.item2.list1"), t("tenant.scene.item2.list2")],
      img: t("tenant.scene.item2.img"),
    },
    {
      title: t("tenant.scene.item3.title"),
      lists: [
        t("tenant.scene.item3.list1"),
        t("tenant.scene.item3.list2"),
        t("tenant.scene.item3.list3"),
      ],
      img: t("tenant.scene.item3.img"),
    },
  ];
  return (
    <div>
      <section className="tenant-scene">
        <div className="inner basic-column">
          <div className="tenant-scene-warp">
            <div className="tenant-scene-content-warp">
              <div className="title">{t("tenant.scene.title")}</div>
              <div className="tenant-scene-item-warp">
                {SceneItemData.map((item, index) => (
                  <SceneItem
                    {...item}
                    currentIndex={currentIndex}
                    index={index}
                    setCurrentIndex={setCurrentIndex}
                  />
                ))}
              </div>
            </div>
            <div className="tenant-scene-img-warp">
              {SceneItemData.map((item, index) => {
                const className = classNames({
                  "tenant-scene-img": true,
                  appear: currentIndex === index,
                });
                return (
                  <div className={className}>
                    <img src={item.img} alt="authing" />
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
